import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";
export const getJobsByStatuses = (year, employeeId, departmentId, serviceId, includeInactive = false) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.get(
                `${FIRMFLOWURL}api/Analytics/JobStatusReport`,
                {
                    headers: { Authorization: token },
                    params: { year, employeeId, departmentId, serviceId, includeInactive: Boolean(includeInactive) },
                }
            );
            resolve({ ...response, success: true });
        } catch (err) {
            console.log(err);
            if (err.message.includes(401)) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }
            resolve({ success: false, message: err.message });
        }
    });
};
